<template>
    <span>{{ name }}</span>
</template>

<script>
export default {
    name: "TableCellCustomerId",
    props: {
        item: Object,
        value: Number
    },
    computed: {
        customerId() {
            return this.value
        },
        name() {
            if (this.item.firstName) {
                return this.item.firstName + ' ' + this.item.lastName
            } else {
                return this.customerName
            }
        }
    },
    asyncComputed: {
        async customerName() {
            if (this.customerId) {
                const customer = await this.$store.dispatch('itemData/get', {
                    tableName: 'm_registrants_registrants',
                    id: this.customerId
                })

                return customer.firstName + ' ' + customer.lastName
            }
        }
    }
}
</script>